<div class="row">
	<div class="col-md-2"></div>
		<div class="col-md-8">
			<video width="100%" height="auto" controls autoplay>
			  <source src="/assets/emotions_and_physical_health.mp4" type="video/mp4">
			Your browser does not support the video tag.
			</video>
		</div>
	<div class="col-md-2"></div>
</div>

<br>

<div class="row">
<div class="col-md-4"></div>
<div class="col-md-4"><img src="http://tranqsleep.com/wp-content/uploads/2021/09/41.png" width="100%" height="auto"></div>
<div class="col-md-4"></div>
</div>
<mat-card>
    <mat-card-content>



        <p style="color : #002E46 !important;">
            There are many factors that can potentially affect your sleep: diet, exercise, medical conditions, emotions,
            physical and psychiatric health, and social support.
        </p>
        <br>

        <p style="color : #002E46 !important;">
            Each of these factors will not only directly affect your sleep, but also affect each other to indirectly
            affect your sleep.
        </p>
        <br>
        <p style="color : #002E46 !important;">
            It is therefore important to address all of these factors at once. However, a step-by-step approach can be
            considered if it is too overwhelming to tackle all problems at once.
        </p>



    </mat-card-content>
</mat-card>







<mat-accordion class="example-headers-align" multi="false">
    <mat-expansion-panel class="ion-text-left">

        <mat-expansion-panel-header>

            <mat-panel-title style="font-weight: bold; color : #002E46 !important;">

                HOW TO MANAGE PHYSICAL & EMOTIONAL HEALTH


            </mat-panel-title>

        </mat-expansion-panel-header>
        <p style="color : #002E46 !important;">
            In this day and age, we are constantly bombarded with many life stressors; therefore, it is important for us
            to be intentional and be mindful of our body and mind. As we are aware, mental activity, emotions, and
            physical busyness can cause our brain to be “too busy or active” to sleep.


        </p>
        <br>
        <p style="color : #002E46 !important;">

            Things such as worrying in bed and overthinking about our stress can also lead to anxiety and depression. It
            is therefore important to do self-assessments regularly to determine the factors that are affecting your
            sleep. Such assessments will increase your awareness and understanding of the thoughts, behaviors and health
            symptoms causing your insomnia. Once these factors are identified, you can cultivate a greater sense of
            control over your sleep.

        </p>



    </mat-expansion-panel>

    <!---->
    <mat-expansion-panel class="ion-text-left">

        <mat-expansion-panel-header>
            <mat-panel-title style="font-weight: bold; color : #002E46 !important;">
                SELF ASSESSMENT
            </mat-panel-title>

        </mat-expansion-panel-header>
        <p style="color : #002E46 !important;">
            <strong>Is your daytime stress causing your insomnia? </strong>



        </p>
        <br>

        <p style="color : #002E46 !important;">
            Assess your stress level throughout the day, take intentional breaks, and develop a plan of action to
            resolve or at least minimize the stressors in your life.


        </p>
        <br>
        <p style="color : #002E46 !important;">
            <strong> Are you carrying worry to your bedtime?
            </strong>
            Are you ruminating negative thoughts while trying to fall asleep?

        </p>

        <br>
        <p style="color : #002E46 !important;">

            There are many strategies that can be employed to power down your brain. Here are some examples:


        </p>
        <br>

        <table style="width:100%">

            <tr>
                <td style="color : #002E46 !important;">Reduce your stimulus prior to bedtime </td>
                <td style="color : #002E46 !important;">Take away any distractions and minimize any type of activity that will stimulate your brain</td>

            </tr>
            <tr>
                <td style="color : #002E46 !important;">Schedule “Worry Time” </td>
                <td style="color : #002E46 !important;">Set aside a time to deal with what is worrying you</td>

            </tr>
            <tr>
                <td style="color : #002E46 !important;">Create a relaxation routine to power down your brain</td>
                <td style="color : #002E46 !important;">Practice breathing techniques
                </td>

            </tr>
            <tr>
                <td style="color : #002E46 !important;">Maintain a consistent sleep schedule</td>
                <td style="color : #002E46 !important;">Regularity is king. Go to bed at the same time and wake up at the same, as this will anchor your
                    sleep.</td>

            </tr>
            <tr>
                <td style="color : #002E46 !important;">Get out of bed when you're not sleepy</td>
                <td style="color : #002E46 !important;">Do progressive muscle relaxation</td>

            </tr>
        </table>


        <mat-card style="background-color: #e9f3f1;">
            <mat-card-content>
                <mat-card-header>
                    <mat-card-title style="font-weight: bold; color : #002E46 !important;" class="ion-text-center">Key Points</mat-card-title>

                </mat-card-header>


                <p style="color : #002E46 !important;">
                    There are many factors that can potentially affect your sleep. We need to address all of these
                    factors in order to improve your sleep.
                </p>
                <br>

                <p style="color : #002E46 !important;">
                    Do self-assessments regularly to determine the factors that are affecting your sleep. These
                    assessments will increase your awareness and understanding of the thoughts, behaviors and health
                    symptoms causing your insomnia. Once these factors are identified, you can cultivate a greater sense
                    of control over your sleep.
                </p>
                <br>
                <p style="color : #002E46 !important;">
                    We are constantly bombarded with many life stressors, so it is important to employ strategies to
                    power down your brain.

                </p>

                <br>


            </mat-card-content>
        </mat-card>


    </mat-expansion-panel>
    <!---->
</mat-accordion>